import React, { useContext, useEffect, useState } from "react";

import { JobsContext } from "context/providers";

import AppDialog from "components/AppDialog";
import Button from "components/Button";
import FeatureFlag from "components/FeatureFlag";
import JobOppDetailsCard from "components/JobOppDetailsCard";
import { DialogTitle } from "components/ui/dialog";

const JobModal = ({ user, onClose }) => {
  const {
    jobOpp,
    loadingJobOpp,
    resetSimilarJobOppsFilters,
    clearJob,
    initJob,
  } = useContext(JobsContext);
  const [editJobLinkClicked, setEditJobLinkClicked] = useState(false);

  useEffect(() => {
    if (!loadingJobOpp && jobOpp) {
      resetSimilarJobOppsFilters();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingJobOpp]);

  const callOnClose = () => {
    clearJob(jobOpp.id);
    initJob(jobOpp.id);
  };

  const handleClose = () => {
    if (editJobLinkClicked) {
      callOnClose();
      // This is unecessary but adds clarity to the behavior
      setEditJobLinkClicked(false);
    }
    onClose();
  };

  return (
    <AppDialog
      open
      onClose={handleClose}
      header={
        <>
          <div>
            <DialogTitle className="font-inter text-xl font-semibold text-slate-700">
              Job Details
            </DialogTitle>
          </div>
          <div>
            <FeatureFlag flag="JOB_EDIT_BUTTON_ENABLED">
              {jobOpp?.id && (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${process.env.REACT_APP_DOMAIN}/#/jobs/opportunities/${jobOpp.id}/edit`}
                  onClick={() => setEditJobLinkClicked(true)}
                >
                  <Button className="md:mr-8 rounded-md border border-solid border-slate-300 bg-white px-4 py-2 font-inter text-sm font-medium normal-case text-slate-700 shadow-none hover:text-slate-700 hover:shadow-none">
                    <span className="w-full text-center">Edit Job</span>
                  </Button>
                </a>
              )}
            </FeatureFlag>
          </div>
        </>
      }
      className="max-h-[80vh] w-[80vw] max-w-[80vw] rounded-lg"
    >
      <JobOppDetailsCard user={user} />
    </AppDialog>
  );
};

export default JobModal;
